/**
 * Stockage des url d'appels distants
 */
export class ExternalAPI {

  /** URL du user récupérer grâce au token de keycloak
   * LMA: pas une URL, une méthode...
   */
  public static readonly USER_INFO: string = 'userInfo';
 
  /**
  * méthode de mémorisation des données de cnx du user par dom.bu.vision
  */
 public static readonly USER_TIMESTAMP: string = 'userTimestamp';

  /** chargement des données d'un widget */
  public static readonly DATA_LITE_API: string = 'data.do';

  /** Récupération des valeurs de données d'un widget */
  public static readonly DATA_LITE_VALUES_API: string = 'datavalue.do';

  /** Récupération du nombre de données d'un widget */
  public static readonly DATA_COUNT_API: string = 'data.count';

  /** service de commit par EMPack */
  public static readonly COMMIT_API: string = 'commit.do';

  /** service de commit composite (FD / BL) */
  public static readonly DATA_COMMIT_API: string = 'datacommit.do';
  
  /** service de commit composite (WORKOML) */
  public static readonly WORKOM_COMMIT_API: string = 'workcomcommit.do';

  /** service de check composite (FD / BL) */
  public static readonly DATA_CHECK_API: string = 'datacheck.do';

  /** service de check Workcom */
  public static readonly WORKCOM_CHECK_API: string = 'workcomcheck.do';

  /** collecte des EMs deleted par type  */
  public static readonly DELETED_EMS_API: string = 'deletedems.do';

  /** tracking */
  public static readonly TRACK_API: string = 'track.do';

  /** service EntityModifications */
  public static readonly EM_API: string = 'em.do';

  /** EndPoint de l'API Business Unit */
  public static readonly BU_API: string = 'businessunit.do';


  /** EndPoint de l'API PhysicalTemplate */
  public static readonly PHYSICALTEMPLATE_API: string = 'physicaltemplate.do';

  /** EndPoint de l'API PhysicalTemplate */
  public static readonly TABS_API: string = 'tabs.do';

  /** Récupération des médias */
  public static readonly ATTACHMENTS: string = 'attachment.do';
  public static readonly ATTACHMENTV2: string = 'attachmentv2.do';

  /* ################################################
                       CHRONOCODES
      ################################################ */

  /** URL for chronocode */
  public static readonly CHRONOCODE_API: string = 'chronocode.do';

  /** URL for time gap */
  public static readonly TIMEGAP_API: string = 'timegap.do';

  /* ##############################################
                       FREE DATA
      ############################################## */

  /** URL for FreeData */
  public static readonly FREEDATA_API: string = 'freedata.do';

  /** URL pour freedataValue */
  public static readonly FREEDATA_VALUE_API: string = 'freedatavalue.do';


  /** URL pour compter les freedata et avoir le max revnumber sur les fds */
  public static readonly FREEDATA_COUNT_API: string = 'freedata.count';

  /** prochaine séquence sur FDV */
  public static readonly FREEDATA_SEQUENCE_API: string = 'freedata.next';


  /** URL for FreeData */
  public static readonly INCEXCKEY_API: string = 'incexckey.do';

  /** URL for FreeData */
  public static readonly CONNECT_API: string = 'connectaction.do';

  /* ##############################################
                   LANGUAGE
   ############################################## */

  /** URL for language */
  public static readonly LANGUAGE_API: string = 'language.do';

  /* ###############################
                PAYS
      ############################### */

  /** URL for Country */
  public static readonly COUNTRY_API: string = 'country.do';

  /* ###############################
           User, Profiles, Roles
   ############################### */

  /** URL for role */
  public static readonly ROLE_API: string = 'role.do';

  /** URL for user context */
  public static readonly USER_CONTEXT_API: string = 'context.do';

  /** URL for feature */
  public static readonly FEATURE_API: string = 'feature.do';

  /** URL profils */
  public static readonly PROFILE_API: string = 'profile.do';

  /** URL du user récupérer grâce au token de keycloak */
  public static readonly USER: string = 'user.do';

  /* ###############################
      mesures, styles et associés
   ############################### */

  /** Endpoint des measures */
  public static readonly MEASURE_API: string = 'measure.do';
  /** Endpoint des grilles de poids */
  public static readonly WG_API: string = 'wg.do';
  /** Endpoint des constantes */
  public static readonly CONSTANT_API: string = 'constant.do';
  /** Endpoint des styles */
  public static readonly STYLE_API: string = 'style.do';
  /** Endpoint des format */
  public static readonly FORMAT_API: string = 'format.do';
  /** Endpoint des rendus css */
  public static readonly CSS_API: string = 'css.do';
  /** Endpoint des scenarii */
  public static readonly SCENARIO_API: string = 'scenario.do';
  /** Endpoint des messages */
  public static readonly WORKCOM_API: string = 'workcom.do';

  /** URL pour compter les WORKCOM et avoir le max revnumber  */
  public static readonly WORKCOM_COUNT_API: string = 'workcom.count';

  /* ###############################
        Matrices  de données
      ############################### */

  /** Find des matrices de données */
  public static readonly MATRIX_API: string = 'matrix/find';
  /** Chargement des données d'une matrice */
  public static readonly MATRIX_LOAD_DATAS: string = 'matrix/load';

  /* ###############################
           visions
   ############################### */

  /** find sur vision */
  public static readonly VISION_API: string = 'vision.do';
  /** find sur visionSteps */
  public static readonly VISION_LOAD_STEPS: string = 'visionapp/loadsteps.do';
  /** gestion des visionStepPerimeters */
  public static readonly VISION_STEP_PERIMETERS: string = 'visionstepperimeter.do';
  /** génération des lignes de vision */
  public static readonly VISION_MANAGELINE_LINES: string = 'visionapp/managelines.do';
  /** nb lignes / values par vision */
  public static readonly VISION_STATS: string = 'visionapp/stats.do';
  /** nb lignes / values par scenar */
  public static readonly SCENARIO_STATS: string = 'scenarioapp/stats.do';


  /* ###############################
                  Batch
  ############################### */

  /** demande d'export */
  public static readonly BATCH_EXPORT: string = 'batch/export.do';
  /** import fichier utilisateur */
  public static readonly BATCH_UPLOAD_FILE: string = 'batch/uploadfile.do';

  /** fonction connect */
  public static readonly CALL_CONNECT: string = 'connect/run.do';
  public static readonly CALL_CONNECT_V2: string = 'run.do'; // passage v2 
  
  /** bulker sur baselineValues pour I => S */
  public static readonly BASELINE_VALUE_BULKER: string = 'baseline/bulkvalues.do';

  /* ###############################
                  DOM
  ############################### */


  /** URL du user récupérer grâce au token de keycloak */
  public static readonly USER_PASSWORD: string = 'userPassword';

  /* ###############################
                  Compute
  ############################### */
  
  /** chargement d'une page compute */
  public static readonly GET_COMPUTE: string = 'do';

  /* ##############################################
                   Connect
   ############################################## */

  /** URL connexions */
  public static readonly CONNECTION_API: string = 'connection.do';

  /** URL process */
  public static readonly PROCESS_API: string = 'process.do';
  
  /** URL process */
  static readonly META_PROCESS_API: string = 'metaprocess.do';

  /** URL flow */
  public static readonly FlOW_API: string = 'flow.do';

  /** URL procedure */
  public static readonly PROCEDURE_API: string = 'procedure.do';

  /* ##############################################
                appels IA
   ############################################## */

  /** question / résumé */
  public static readonly IA_TEXT_API: string = 'external/iatext';
 
  /** traduction */
  public static readonly IA_TRANSLATE_API: string = 'external/iatranslate';
 
  /** génération d'une image */
  public static readonly IA_IMAGE_API: string = 'external/iaimage';

  /** lecture d'un CV */
  public static readonly IA_CV_API: string = 'external/iacv';

  /** vecteurs d'un texte */
  public static readonly IA_VECTOR_API: string = 'external/iavector';

  /** image en texte */
  public static readonly IA_IMAGETOTEXT_API: string = 'external/imagetotext';


}
